import ManageAccountScreen from 'features/lineOfCredit/screens/manageAccount/ManageAccountScreen';
import React from 'react';

export default function Page() {
  return <ManageAccountScreen />;
}
